import { ThemeProvider } from "@emotion/react";
import { observer } from "mobx-react-lite";
import { useSingleton } from "../injection";
import { ThemeStore, themeRegistry } from "../../other/theme";
import { ReactNode } from "react";

const Provider = observer((props: { children: ReactNode }) => {
    const themeStore = useSingleton(ThemeStore);
    return (
        <>
            {/* ThemeProvider should only contain props.children to avoid unneccessary re-renders */}
            <ThemeProvider theme={themeStore.theme}>
                {props.children}
            </ThemeProvider>
        </>
    );
});

interface IProps {
    theme?: string;
    children: ReactNode;
}

export const BridgeThemeProvider = (props: IProps) => {
    if (props.theme) {
        const theme = themeRegistry.find(x => x.name === props.theme);
        if (!theme) {
            throw new Error(`Invalid theme name "${props.theme}"`);
        }
        return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
    }
    return <Provider>{props.children}</Provider>;
};
